<template>
  <v-text-field
    class="input-filter"
    v-model="text"
    label="Buscar" 
    hide-details 
    solo 
    outlined 
    flat 
    dense 
    height="28px"
  >
  </v-text-field>
</template>

<script>
export default {
  components: {
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      text: null,
    }
  },
  created() {
  },
  watch: {
    value(newValue) {
      this.text = newValue
    },
    text(newText) {
      this.$emit('input', newText); // Emitir el nuevo valor
    },
  },
}
</script>

<style scope>
  .input-filter .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
  }

  .input-filter.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 28px;
  }

  .input-filter input {
    font-size: 12px !important;
  }

  .input-filter label {
    font-size: 12px !important;
  }
</style>